module.exports = __webpack_public_path__ + "static/media/real-amalfi.2985b4eb.png";